"use client"

import styled from "@emotion/styled"
import { sharedColors } from "ui/theme/colors"
import { extractProperty } from "utils"
import AnimationHero from "./AnimationHero"
import MediaHero from "./MediaHero"

const OuterContainer = styled.div<{ $isGray?: boolean }>`
  width: 100%;
  background-color: ${({ $isGray }) =>
    $isGray ? sharedColors.mediumGrayLight : "transparent"};
`

type UndStr = string | undefined

export type FormObject = {
  title: UndStr
  searchTitle: UndStr
  searchDescription: UndStr
  button: UndStr
  buttonText: UndStr
}

type Props = {
  data: any
  locale: string
  blockIndex?: number
  isHomepage?: boolean
}

export default function Hero({ data, locale, blockIndex, isHomepage }: Props) {
  const imageOrVideo = extractProperty(data, "imageOrVideo") as UndStr
  const title = extractProperty(data, "title") as UndStr
  const searchTitle = extractProperty(data, "searchTitle") as UndStr
  const searchDescription = extractProperty(data, "searchDescription") as UndStr
  const button = extractProperty(data, "button")?.[0]?.url as UndStr
  const buttonText = extractProperty(data, "button")?.[0]?.name as UndStr

  const formObject = {
    title,
    searchTitle,
    searchDescription,
    button,
    buttonText,
  }
  const isGray = isHomepage && typeof blockIndex === "number" && blockIndex % 2 === 1
  return (
    <OuterContainer $isGray={isGray}>
      {imageOrVideo ? (
        <MediaHero source={imageOrVideo} formObject={formObject} />
      ) : (
        <AnimationHero formObject={formObject} locale={locale} />
      )}
    </OuterContainer>
  )
}
